// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import wallet from '@/store/wallet'

import Home from '@/views/home.vue'
import Market from '@/views/market/index.vue'
import MarketOrders from '@/views/market/orders.vue'
import Team from '@/views/team/index.vue'
import Income from '@/views/income/index.vue'
import Me from '@/views/me/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requireAuth: true }
  },
  {
    path: '/market',
    name: 'Market',
    component: Market,
    meta: { requireAuth: true }
  },
  {
    path: '/market/orders',
    name: 'MarketOrders',
    component: MarketOrders,
    meta: { requireAuth: true }
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
    meta: { requireAuth: true }
  },
  {
    path: '/income',
    name: 'Income',
    component: Income,
    meta: { requireAuth: true }
  },
  {
    path: '/me',
    name: 'Me',
    component: Me,
    meta: { requireAuth: true }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash', // 如果服务器没配 history fallback，就改成 'hash'
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta && r.meta.requireAuth)) {
    const token = wallet.state?.token
    if (!token) {
      wallet.state.showModal = true
      return next()
    }
  }
  next()
})

export default router